export default __webpack_public_path__ + "static/media/logo.08b2865e.png";